// @flow

import React, { useEffect, type Node } from 'react';
import { useUserInputAsSelect, useUserInputValue } from '@tectonics/prs/user-input-values';
import { useUniqueId, useMustShow } from '@tectonics/hooks';
import { useSubmitting } from '@tectonics/prs/submitting';
import { useUserInputValidationError } from '@tectonics/prs/validation';
import { useFormHasBeenSent } from '@tectonics/prs/form-status';

import { Select, SelectOption } from '../../../../atoms';
import { ErrorLabel } from '../../../../molecules/error-label';
import { useCurrentPaymentTypeOptionalFields } from '@tectonics/prs/incoming-payment/get-payment-type-optional-fields';

export function FieldColombianDocumentType(): Node {
  const [value, handleChange] = useUserInputAsSelect('colombianDocumentType');
  const [, setDocument] = useUserInputValue('colombianDocument');
  const mustShow = useMustShow('colombianDocument');
  const submitting = useSubmitting();
  const inputId = useUniqueId();

  const validationError = useUserInputValidationError('colombianDocumentType');
  const formHasBeenSent = useFormHasBeenSent();

  useEffect(() => {
    setDocument('');
  }, [setDocument, value]);

  const isOptionalFieldByPaymentType = useCurrentPaymentTypeOptionalFields('document');

  if (isOptionalFieldByPaymentType) {
    return null;
  }

  if(!mustShow)
    return null;

  return(
    <div data-test-name="customer-document-type">
      <label htmlFor={inputId}>
        Tipo de identificación
      </label>
      <Select
        id={inputId}
        value={value}
        onChange={handleChange}
        readOnly={submitting}
        fashion={formHasBeenSent && validationError ? 'error' : null}
        data-error={formHasBeenSent && validationError ? 'error' : null}
        name="customer-document-type"
      >
        <SelectOption value="CC">Cédula de Ciudadanía</SelectOption>
        <SelectOption value="NIT">NIT</SelectOption>
        <SelectOption value="CE">Cédula de Extranjería</SelectOption>
      </Select>

      {formHasBeenSent && validationError && (
        <ErrorLabel>El documento elijido es inválido</ErrorLabel>
      )}
    </div>
  );
}
